document.addEventListener('DOMContentLoaded', () => {
  const toast = document.createElement('div');
  toast.className = 'fb-bundle-toast';
  toast.setAttribute('role', 'status');
  document.body.appendChild(toast);

  let toastTimer;

  function showToast(message) {
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 4000);
  }

  document.querySelectorAll('.fb-shop__bundle a.fb-btn[data-bundle-items]').forEach((btn) => {
    btn.addEventListener('click', async (event) => {
      event.preventDefault();
      if (btn.classList.contains('fb-bundle-loading')) return;

      let items;
      try {
        items = JSON.parse(btn.dataset.bundleItems);
      } catch (err) {
        return;
      }
      if (!items.length) {
        window.location = btn.href;
        return;
      }

      btn.classList.add('fb-bundle-loading');
      const originalText = btn.textContent;
      btn.textContent = 'Adding…';

      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items }),
        });
        const parsed = await response.json();
        if (!response.ok || parsed.status) {
          throw new Error(parsed.description || parsed.message || 'add failed');
        }
        window.location = window.routes.cart_url;
        return;
      } catch (err) {
        console.error(err);
        showToast('Some products in this bundle are sold out. Please check back soon.');
        btn.classList.remove('fb-bundle-loading');
        btn.textContent = originalText;
      }
    });
  });
});
